var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0",
      attrs: { id: "annonce-create-step-right-part" }
    },
    [
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { id: "annonce-create-step-right-part-inside" }
        },
        [
          _vm.isLicensedAndNeedVIN
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-1" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mb-1"
                    },
                    [
                      _c("div", { staticClass: "small-text" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("annonce.vehicle.vin")) + " "
                        ),
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.$t("annonce.vehicle.vin.mandatory"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass:
                          "secondary-text-color ph-custom ph-question-fill cursor-pointer",
                        on: { click: _vm.openVinInfoModal }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "invalid-feedback": _vm.vin.invalidFeedback,
                        vin: _vm.vin.state,
                        "label-for": "vin-input"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "vin-input",
                          formatter: _vm.IdentifierUtils.formatVin,
                          state: _vm.vin.state
                        },
                        on: {
                          change: function($event) {
                            _vm.setAnnonce
                            _vm.updateFeedbackVin()
                          }
                        },
                        model: {
                          value: _vm.vin.value,
                          callback: function($$v) {
                            _vm.$set(_vm.vin, "value", $$v)
                          },
                          expression: "vin.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isLicensedAndNeedVIN
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-1" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "small-text",
                      attrs: {
                        "invalid-feedback": _vm.fiscalPower.invalidFeedback,
                        label: _vm.$t("annonce.vehicle.engine.Power"),
                        "label-for": "engine-power-input"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "engine-power-input",
                          state: _vm.fiscalPower.state,
                          min: "0",
                          step: "1",
                          type: "number"
                        },
                        on: { change: _vm.setAnnonce },
                        model: {
                          value: _vm.fiscalPower.value,
                          callback: function($$v) {
                            _vm.$set(_vm.fiscalPower, "value", $$v)
                          },
                          expression: "fiscalPower.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isLicensedAndNeedVIN
            ? _c("AutocompleteField", {
                key: _vm.autocompleteKey,
                ref: "autocomplete",
                staticClass: "col-12 pl-0 pr-0 mb-1",
                attrs: {
                  "initial-value": this.annonce.finitions.value,
                  "input-label": _vm.$t("annonce.vehicle.Finitions"),
                  invalidFeedback: _vm.finitions.invalidFeedback,
                  items: _vm.finishes,
                  "need-create-if-empty": true,
                  "ready-to-set-initial-value": _vm.readyToSetInitialType,
                  state: _vm.finitions.state,
                  "input-class": "small-text mb-4",
                  "input-id": "type-input"
                },
                on: {
                  createNewItem: _vm.createNewItem,
                  newSelectedValue: _vm.getSelectedType
                },
                model: {
                  value: _vm.finitions.value,
                  callback: function($$v) {
                    _vm.$set(_vm.finitions, "value", $$v)
                  },
                  expression: "finitions.value"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasWindowEngravingVehicleType
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mt-1" },
                [
                  _c("b-form-group", {
                    attrs: {
                      "invalid-feedback":
                        _vm.hasWindowEngraving.invalidFeedback,
                      state: _vm.hasWindowEngraving.state
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var ariaDescribedby = ref.ariaDescribedby
                            return [
                              _c(
                                "b-form-checkbox",
                                {
                                  staticClass: "mb-3 mt-2 radio-proprio",
                                  on: { change: _vm.setAnnonce },
                                  model: {
                                    value: _vm.hasWindowEngraving.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.hasWindowEngraving,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "hasWindowEngraving.value"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t("annonce.has.WindowEngraving")
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3911409807
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    "invalid-feedback": _vm.annonceDescription.invalidFeedback,
                    label: _vm.$t("annonce.context.robbery"),
                    "label-for": "annonceDescription-input"
                  }
                },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      id: "annonceDescription-input",
                      state: _vm.annonceDescription.state
                    },
                    on: { change: _vm.setAnnonce },
                    model: {
                      value: _vm.annonceDescription.value,
                      callback: function($$v) {
                        _vm.$set(_vm.annonceDescription, "value", $$v)
                      },
                      expression: "annonceDescription.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("annonce-create-vehicle-generic-modal", {
            attrs: {
              "brand-id": this.annonce.brand.value,
              "initial-name": _vm.customName,
              "model-id": this.annonce.model.value,
              "vehicle-type-id": this.annonce.vehicleType.value,
              "controller-name": "modelFinish",
              "label-input": "annonce.empty.create.finish.label",
              "method-name": "createCustomModelFinish",
              "title-modal": "annonce.empty.create.finish.title"
            },
            on: { returnCreateCustom: _vm.getCreatedCustom }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal",
          staticClass: "vin-info-modal",
          attrs: { id: "vin-info-modal", centered: "", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function(ref) {
                var close = ref.close
                return [
                  _c("span", { staticClass: "vin-info-header-icon" }, [
                    _c("i", {
                      staticClass: "ph-custom ph-question-fill",
                      staticStyle: {
                        "font-size": "60px",
                        color: "var(--main-grey-dark)"
                      }
                    })
                  ])
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("div", [
            _c("p", {
              staticClass: "page-title vin-info-title mt-0 mb-3",
              domProps: { innerHTML: _vm._s(_vm.$t("vin.info.title")) }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "vin-info-text mt-2",
              domProps: { innerHTML: _vm._s(_vm.$t("vin.info.content")) }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-644dd2a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644dd2a3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceCreateStep5.vue
// module id = vQ84
// module chunks = 0